import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"

import App from "./App"
import "./appGlobals"
import "./index.css"
import reportWebVitals from "./reportWebVitals"
import "./styles/globals.less"
import "./styles/index.less"
import ScrollThemeProvider from "./theme"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)

root.render(
  <ScrollThemeProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ScrollThemeProvider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
